// extracted by mini-css-extract-plugin
module.exports = {"footer":"AIWysiwygWrapper_footer__ypnSX","aiButton":"AIWysiwygWrapper_aiButton__3D95y"};